import React from 'react';
import { AppContextProvider } from './src/lib/context';
import { AnimatePresence } from 'framer-motion';

export const wrapRootElement = ({ element }) => <AppContextProvider>{element}</AppContextProvider>;

export const wrapPageElement = ({ element, props }) => (
  <AnimatePresence exitBeforeEnter>{element}</AnimatePresence>
);
